var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-toasts"},[_c('transition-group',{attrs:{"name":"slide-x-transition"}},_vm._l((_vm.toasts),function(toast,index){return _c('AppToast',{key:toast.id,attrs:{"toast":toast,"index":index}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }